import { render, staticRenderFns } from "./PartyForm.vue?vue&type=template&id=35400f76&scoped=true"
import script from "./PartyForm.vue?vue&type=script&lang=js"
export * from "./PartyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35400f76",
  null
  
)

export default component.exports